export default "__VITE_ASSET__9eefe136__"